import { render, staticRenderFns } from "./preView_or_edit.vue?vue&type=template&id=5022e6d0&scoped=true"
import script from "./preView_or_edit.vue?vue&type=script&lang=js"
export * from "./preView_or_edit.vue?vue&type=script&lang=js"
import style0 from "./preView_or_edit.vue?vue&type=style&index=0&id=5022e6d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022e6d0",
  null
  
)

export default component.exports